import Appsignal from '@appsignal/javascript';
import { JSClient } from '@appsignal/types';
import { readVarM } from './src/Assertions/environments';
import { Maybe } from 'maybeasy';

const appsignal: Maybe<JSClient> = readVarM('VITE_APPSIGNAL_PUSH_API_KEY').map(
  (key: string) =>
    new Appsignal({
      key: key,
      namespace: 'admin_studio',
    }),
);

export default appsignal;
